export enum HorizontalPosition {
  Left = 'left',
  Right = 'right'
}
